import { Injectable, signal } from '@angular/core';

const SHOW_DELAY_MS = 200;

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly activeRequests = signal(0);
  private readonly visible = signal(false);
  private showTimer: ReturnType<typeof setTimeout> | null = null;

  readonly loading = this.visible.asReadonly();

  show(): void {
    this.activeRequests.update((count) => count + 1);

    if (this.activeRequests() !== 1 || this.showTimer) {
      return;
    }

    this.showTimer = setTimeout(() => {
      this.showTimer = null;
      if (this.activeRequests() > 0) {
        this.visible.set(true);
      }
    }, SHOW_DELAY_MS);
  }

  hide(): void {
    this.activeRequests.update((count) => Math.max(0, count - 1));

    if (this.activeRequests() > 0) {
      return;
    }

    if (this.showTimer) {
      clearTimeout(this.showTimer);
      this.showTimer = null;
    }

    this.visible.set(false);
  }
}
